import types from '../../actions/types';
import {
    paginatedResultReducer
} from '../common/paginated_results';
import {
    removeItem
} from '../common/remove-item';

const initialState = {
    loading: false
};

export default function partnersReducer(state = initialState, action) {
    switch (action.type) {
        case types.ADMIN_LOAD_PARTNER_CATEGORY.REQUEST:
            return {
                ...state,
                category: {},
                loading: true
            };

        case types.ADMIN_LOAD_PARTNER_CATEGORY.SUCCESS:

            return {
                ...state,
                category: action.payload,
                loading: false
            };

        case types.SUBMIT_PARTNER_CATEGORY.SUCCESS:
            return {
                ...state,
                category: action.payload,
                loading: false
            };
        case types.DELETE_PARTNER_CATEGORY.SUCCESS:
            return {
                ...state,
                categories: {
                    ...state.categories,
                    items: removeItem(state.partners.items, action.payload.id)
                }

            };
        default:
            return {
                ...state,
                categories: paginatedResultReducer(state.categories, types.ADMIN_LOAD_PARTNER_CATEGORIES, action)
            };
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/admin/partnerCategories.js